import styled from 'styled-components';
import { LINE_HEIGHT, BREAKPOINT, COLOR } from '@latitude/core/utils/constants';
import { Text } from '@latitude/text';
export var Outer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FinePrintstyles__Outer",
  componentId: "sc-1at0kbu-0"
})(["margin:0 -15px;@media (min-width:", "){margin:0;}"], BREAKPOINT.LG);
export var StyledText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "FinePrintstyles__StyledText",
  componentId: "sc-1at0kbu-1"
})(["line-height:", ";a{color:", ";}"], LINE_HEIGHT.TIGHT.SMALL, COLOR.BLUE);